import { PRESS } from "../data/portfolio";
import { ArrowUpRight } from "lucide-react";

export default function PressPage() {
  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 md:py-24" data-testid="press-page">
      <div className="mb-14 reveal">
        <div className="text-xs uppercase tracking-[0.4em] text-[var(--ember)] mb-4">Press</div>
        <h1 className="font-serif text-6xl md:text-8xl leading-[0.85] text-[var(--paper)] italic">Press</h1>
      </div>

      <div className="space-y-0">
        {PRESS.map((item, idx) => (
          <a
            key={idx}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group block py-10 border-t hairline reveal first:border-t-0 first:pt-0"
            style={{ transitionDelay: `${idx * 60}ms` }}
          >
            <div className="flex items-start gap-8">
              {item.image && (
                <div className="hidden md:block flex-shrink-0 w-52 h-32 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className={`w-full h-full transition-transform duration-700 group-hover:scale-[1.03] ${
                      item.image.endsWith(".png") ? "object-contain" : "object-cover"
                    }`}
                  />
                </div>
              )}
              <div className="flex-1">
                <div className="flex items-center gap-4 mb-3">
                  <span className="text-xs uppercase tracking-[0.4em] text-[var(--ember)] font-mono">{item.publication}</span>
                  <span className="text-[10px] uppercase tracking-[0.25em] text-[var(--muted)] font-mono">{item.date}</span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl text-[var(--paper)] leading-snug group-hover:text-[var(--ember)] transition-colors duration-300 max-w-3xl">
                  {item.title}
                </h2>
                {item.quote && (
                  <p className="mt-4 text-[var(--bone)] italic text-base leading-relaxed max-w-2xl border-l-2 border-[var(--ember)] pl-4">
                    "{item.quote}"
                  </p>
                )}
              </div>
              <ArrowUpRight
                size={24}
                className="text-[var(--muted)] group-hover:text-[var(--ember)] group-hover:rotate-45 transition-all duration-500 flex-shrink-0 mt-1"
              />
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
